<div
    class="snackbar__item"
    [class.snackbar__item--danger]="style() === 'danger'"
    [class.snackbar__item--warning]="style() === 'warning'"
    [style.animation]="duration | snackbarAnimation: pause"
    (mouseleave)="pause = false"
    (mouseenter)="pause = true"
    (animationend)="onClosed.emit()"
    (click)="onClosed.emit()"
>
    <div class="snackbar__item-content p-3">
        @if (icon) {
            <kui-icon size="xl" class="snackbar__item-content__icon mr-3 mt-1 muted-more" [name]="icon"></kui-icon>
        }
        @if (title || description) {
            <div class="snackbar__item-content__text">
                @if (title) {
                    <h4 class="mb-1">{{ title }}</h4>
                }
                @if (description) {
                    <div>{{ description }}</div>
                }
            </div>
        }
        @if (actionText) {
            <button class="snackbar__item-content__action ml-3" kui-button (click)="onActionClicked.emit()">
                {{ actionText }}
            </button>
        }
    </div>
</div>
